var Recent, Toc, useExpand;

import {
  E,
  useState2
} from '@ppzp/utils.rc';

import {
  useValue_toc
} from 'src/service/book.coffee';

import {
  display,
  useValue_display_target
} from 'src/service/render.coffee';

import './index.styl';

export default function() {
  return E.nav(E({
    plass: 'drawer_container'
  }, E(Toc), E(Recent)));
};

Recent = function() {
  var state_expand;
  state_expand = useExpand(false);
  return E({
    style: state_expand.style
  }, E({
    plass: 'title',
    onClick: state_expand.toggle
  }, E('最近打开'), E({
    plass: 'triangle'
  })), E({
    plass: 'body'
  }, 'TODO: 这里是最近打开的书'));
};

Toc = function() {
  var current_target, list, state_expand;
  state_expand = useExpand(true);
  list = useValue_toc();
  current_target = useValue_display_target();
  return list && E({
    style: state_expand.style
  }, E({
    plass: 'title',
    onClick: state_expand.toggle
  }, E('本书目录'), E({
    plass: 'triangle'
  })), E({
    plass: 'body'
  }, list.map(function(item) {
    return E.a({
      key: item.id,
      href: item.href,
      title: item.label,
      plass: [current_target === item.href && 'selected'],
      onClick: function(evt) {
        evt.preventDefault();
        return display(item.href);
      }
    }, item.label);
  })));
};

useExpand = function(init_value) {
  var state;
  state = useState2(init_value);
  return {
    style: {
      flexGrow: state.value && 1 || 0,
      '--rotate': state.value && 'rotate(0deg)' || 'rotate(90deg)' // 垃圾写法
    },
    toggle: function() {
      return state.set(function(value) {
        return !value;
      });
    }
  };
};
